<template>
  <b-col md="12">
    <section class="informations">
      <knowbefore :property="solution.property.details"  />
    </section>
  </b-col>
</template>

<script>
import KnowBefore from "@liveeps/components/blocks/knowbefore/knowbefore"

export default {
  inheritAttrs: false,
  name: 'informations',

  components: {
    'knowbefore': KnowBefore,
  },

  props: {
    solution: Object,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .informations {
    @media print {
      display: none;
    }
  }

</style>